import { baseApi } from "./baseApi";
import type { SessionResponse, ResolveInstanceResponse } from "../../../shared/types/rbac";

const sessionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createSession: builder.mutation<SessionResponse, void>({
      query: () => ({
        url: "/auth/session",
        method: "POST",
      }),
    }),
    resolveInstance: builder.mutation<ResolveInstanceResponse, { instanceId: string }>({
      query: (body) => ({
        url: "/auth/resolve-instance",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useCreateSessionMutation, useResolveInstanceMutation } = sessionApi;
export { sessionApi };
